import React from "react";
import { Icon } from "semantic-ui-react";

import { COMMUNICATION_CHANNELS } from "../../../util/communication_statuses";

export const getCommunicationChannelIcon = (channel, className) => {
  switch (channel) {
    case COMMUNICATION_CHANNELS.EMAIL:
      return <Icon className={className} name="mail" />;
    case COMMUNICATION_CHANNELS.SMS:
      return <Icon className={className} name="mobile alternate" />;
    case COMMUNICATION_CHANNELS.WHATSAPP:
      return <Icon className={className} name="whatsapp brand" />;
    default:
      return null;
  }
};

export const getCommunicationChannelName = (channel, t) => {
  switch (channel) {
    case COMMUNICATION_CHANNELS.EMAIL:
      return t("cc_email").message || "Email";
    case COMMUNICATION_CHANNELS.SMS:
      return t("cc_sms").message || "SMS";
    case COMMUNICATION_CHANNELS.WHATSAPP:
      return "WhatsApp";
    default:
      return "";
  }
};
